import { Pipe, PipeTransform } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

/**
 * FieldInvalidPipe is a custom Angular pipe that checks if a specific field
 * within a FormGroup or FormArray is invalid. It evaluates the specified field's
 * status based on whether the control is invalid and has been interacted with,
 * either by being marked as dirty or touched.
 *
 * @param {FormGroup | FormArray} form - The form group or form array containing the field.
 * @param {string} fieldName - The name of the form control to check for invalidity.
 * @returns {boolean} - Returns true if the specified field is invalid and either dirty or touched.
 */
@Pipe({
	name: 'isFieldInvalid',
	standalone: true,
	pure: false
})
export class FieldInvalidPipe implements PipeTransform {
	transform(form: FormGroup | FormArray, fieldName: string): boolean {
		const control = form.get(fieldName);
		return !!control && control.invalid && (control.dirty || control.touched);
	}
}
